/* ==================================================
   MONELLO GLOBO ACCORDION 01.10.2026
================================================== */
(function () {
  if (window.monelloGloboAccordionInitialized) return;
  window.monelloGloboAccordionInitialized = true;

  const badgeFor = (text) => {
    const t = (text || '').toLowerCase();
    if (t.includes('persönliche gestaltung')) return 'inklusive';
    if (t.includes('pfotenabdruck')) return '+29 €';
    if (t.includes('besondere veredelungen')) return 'ab 5 €';
    if (t.includes('persönliches detail')) return 'ab 19,95 €';
    if (t.includes('weitere erinnerungen') || t.includes('charm')) return '+9,95 €';
    return '';
  };

  const hasSelectedField = (root) =>
    !!root.querySelector(
      'input:checked, select option:checked:not([value=""]), input[type="text"][value]:not([value=""]), textarea:not(:empty)'
    );

  function enhanceContainer(container) {
    if (!container || container.dataset.monelloAccordionReady === 'true') return;

    const headings = Array.from(
      container.querySelectorAll('.monello-upgrade-headline, .monello-upgrade-subhead')
    );

    if (headings.length < 2) return;

    const headingBlocks = [];
    headings.forEach((heading) => {
      const block = heading.closest('.gpo-element') || heading.parentElement;
      if (block && block.parentElement && !headingBlocks.includes(block)) {
        headingBlocks.push(block);
      }
    });

    if (headingBlocks.length < 2) return;

    container.dataset.monelloAccordionReady = 'true';

    headingBlocks.forEach((block, index) => {
      if (!block.parentElement || block.closest('.monello-gpo-accordion')) return;

      const parent = block.parentElement;
      const nextBlock = headingBlocks[index + 1] || null;

      const wrapper = document.createElement('div');
      wrapper.className = 'monello-gpo-accordion';

      parent.insertBefore(wrapper, block);

      block.classList.add('monello-gpo-accordion__trigger');
      block.setAttribute('role', 'button');
      block.setAttribute('tabindex', '0');
      block.setAttribute('aria-expanded', 'false');

      const heading = block.querySelector('.monello-upgrade-headline, .monello-upgrade-subhead');
      const labelText = heading ? heading.textContent.trim() : '';

      const meta = document.createElement('div');
      meta.className = 'monello-gpo-accordion__meta';

      const badge = badgeFor(labelText);
      if (badge) {
        const badgeEl = document.createElement('span');
        badgeEl.className = 'monello-gpo-accordion__badge';
        badgeEl.textContent = badge;
        meta.appendChild(badgeEl);
      }

      const chevron = document.createElement('span');
      chevron.className = 'monello-gpo-accordion__chevron';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.textContent = '⌄';
      meta.appendChild(chevron);

      block.appendChild(meta);
      wrapper.appendChild(block);

      const content = document.createElement('div');
      content.className = 'monello-gpo-accordion__content';

      let sibling = wrapper.nextSibling;
      while (sibling && sibling !== nextBlock) {
        const move = sibling;
        sibling = sibling.nextSibling;
        content.appendChild(move);
      }

      wrapper.appendChild(content);

      const startsOpen = hasSelectedField(content);
      wrapper.classList.toggle('is-open', startsOpen);
      content.hidden = !startsOpen;
      block.setAttribute('aria-expanded', startsOpen ? 'true' : 'false');

      const toggle = () => {
        const open = !wrapper.classList.contains('is-open');
        wrapper.classList.toggle('is-open', open);
        content.hidden = !open;
        block.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      block.addEventListener('click', (event) => {
        if (event.target.closest('a, input, select, textarea, button')) return;
        toggle();
      });

      block.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });

      content.addEventListener('change', () => {
        if (hasSelectedField(content) && !wrapper.classList.contains('is-open')) {
          wrapper.classList.add('is-open');
          content.hidden = false;
          block.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.gpo-app, .gpo-container').forEach(enhanceContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.monelloGloboAccordionTimer);
    window.monelloGloboAccordionTimer = window.setTimeout(initAccordions, 120);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


/* ==================================================
   MONELLO MERGE 3D INTO VEREDELUNGEN
================================================== */
(function () {
  if (window.monelloMerge3DInitialized) return;
  window.monelloMerge3DInitialized = true;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function merge3D() {
    const accordions = Array.from(document.querySelectorAll('.monello-gpo-accordion'));
    if (!accordions.length) return;

    const veredelungen = accordions.find((box) => {
      const trigger = box.querySelector('.monello-gpo-accordion__trigger');
      return normalize(trigger?.textContent).includes('besondere veredelungen');
    });

    const details3d = accordions.find((box) => {
      const trigger = box.querySelector('.monello-gpo-accordion__trigger');
      return normalize(trigger?.textContent).includes('3d-erinnerungsdetails');
    });

    if (!veredelungen || !details3d || details3d.dataset.monelloMerged === 'true') return;

    const targetContent = veredelungen.querySelector('.monello-gpo-accordion__content');
    const sourceContent = details3d.querySelector('.monello-gpo-accordion__content');
    const sourceTrigger = details3d.querySelector('.monello-gpo-accordion__trigger');

    if (!targetContent || !sourceContent || !sourceTrigger) return;

    const sourceTitle =
      sourceTrigger.querySelector('.monello-upgrade-subhead, .monello-upgrade-headline strong')
        ?.textContent?.trim() || '🤍 3D-Erinnerungsdetails';

    const sourceText =
      sourceTrigger.querySelector('.monello-upgrade-subhead span, .monello-upgrade-headline p')
        ?.textContent?.trim() || 'Kleine persönliche Elemente plastisch auf deiner Urne gestaltet.';

    const subsection = document.createElement('div');
    subsection.className = 'monello-gpo-subsection';

    const title = document.createElement('div');
    title.className = 'monello-gpo-subsection__title';
    title.textContent = sourceTitle;

    const text = document.createElement('div');
    text.className = 'monello-gpo-subsection__text';
    text.textContent = sourceText;

    subsection.appendChild(title);
    subsection.appendChild(text);
    targetContent.appendChild(subsection);

    while (sourceContent.firstChild) {
      targetContent.appendChild(sourceContent.firstChild);
    }

    details3d.dataset.monelloMerged = 'true';
    details3d.remove();
  }

  const scheduleMerge = () => {
    window.clearTimeout(window.monelloMerge3DTimer);
    window.monelloMerge3DTimer = window.setTimeout(merge3D, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMerge);
  } else {
    scheduleMerge();
  }

  const observer = new MutationObserver(scheduleMerge);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==================================================
   MONELLO GPO SINGLE SELECT LOGIC
   Gravur / Pfotenabdruck / Charm mit einem Klick
================================================== */
(function () {
  if (window.monelloGpoSingleSelectInitialized) return;
  window.monelloGpoSingleSelectInitialized = true;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function classify(box) {
    const trigger = box.querySelector('.monello-gpo-accordion__trigger');
    const txt = normalize(trigger?.textContent);
    if (txt.includes('deine persönliche gestaltung')) return 'engraving';
    if (txt.includes('persönlicher pfotenabdruck')) return 'paw';
    if (txt.includes('weitere erinnerungen') || txt.includes('charm-verschluss')) return 'charm';
    return null;
  }

  function getSingleCheckbox(box) {
    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!content) return null;

    const candidates = Array.from(content.querySelectorAll('input[type="checkbox"]'));
    return candidates.find((cb) => {
      const el = cb.closest('.gpo-element');
      return el && !el.closest('.monello-gpo-subsection');
    }) || candidates[0] || null;
  }

  function markSource(cb) {
    const source = cb?.closest('.gpo-element') || cb?.closest('.gpo-checkbox') || null;
    if (source) source.classList.add('monello-gpo-single-source');
  }

  function sync(box, cb) {
    if (!box || !cb) return;
    const checked = !!cb.checked;
    box.classList.toggle('is-selected', checked);

    const content = box.querySelector('.monello-gpo-accordion__content');
    const trigger = box.querySelector('.monello-gpo-accordion__trigger');

    if (!checked && content) {
      content.hidden = true;
      box.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
    }
  }

  function prepare() {
    document.querySelectorAll('.monello-gpo-accordion').forEach((box) => {
      if (box.dataset.monelloSingleReady === 'true') return;
      const type = classify(box);
      if (!type) return;

      const cb = getSingleCheckbox(box);
      if (!cb) return;

      box.dataset.monelloSingleReady = 'true';
      box.dataset.monelloSingleType = type;
      box.classList.add('monello-gpo-single');
      markSource(cb);
      sync(box, cb);

      cb.addEventListener('change', () => sync(box, cb));
    });
  }

  /* Capture phase: fängt den Klick ab, bevor die normale Accordion-Logik läuft */
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.monello-gpo-accordion.monello-gpo-single .monello-gpo-accordion__trigger');
    if (!trigger) return;

    if (event.target.closest('a, input, select, textarea, button')) return;

    const box = trigger.closest('.monello-gpo-accordion');
    const cb = getSingleCheckbox(box);
    if (!box || !cb) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const nextChecked = !cb.checked;

    /* Native Click auslösen, damit Globo eigene Bedingungen/Preise korrekt aktualisiert */
    cb.click();

    const content = box.querySelector('.monello-gpo-accordion__content');

    if (nextChecked) {
      box.classList.add('is-selected', 'is-open');
      if (content) content.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    } else {
      box.classList.remove('is-selected', 'is-open');
      if (content) content.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
  }, true);

  function boot() {
    prepare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.monelloGpoSingleTimer);
    window.monelloGpoSingleTimer = window.setTimeout(prepare, 100);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==================================================
   MONELLO GPO PERSONAL DETAIL + CHARM FIX
================================================== */
(function () {
  if (window.monelloGpoDetailCharmFixInitialized) return;
  window.monelloGpoDetailCharmFixInitialized = true;

  const normalize = (text) =>
    (text || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function findAccordionByText(fragment) {
    return Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((box) =>
      normalize(box.querySelector('.monello-gpo-accordion__trigger')?.textContent).includes(fragment)
    );
  }

  function getPrimaryCheckbox(box) {
    const content = box?.querySelector('.monello-gpo-accordion__content');
    if (!content) return null;
    return Array.from(content.querySelectorAll('input[type="checkbox"]'))[0] || null;
  }

  function setTitlePreserveSubtext(heading, title) {
    if (!heading || heading.dataset.monelloTitleFixed === 'true') return;
    const span = heading.querySelector('span');
    Array.from(heading.childNodes).forEach((node) => {
      if (node !== span && node.nodeType === Node.TEXT_NODE) node.remove();
    });
    heading.insertBefore(document.createTextNode(title + ' '), heading.firstChild);
    heading.dataset.monelloTitleFixed = 'true';
  }

  function syncSelected(box, cb) {
    if (!box || !cb) return;
    box.classList.toggle('is-selected', !!cb.checked);
  }

  function preparePersonalDetail() {
    const box = findAccordionByText('ein ganz persönliches detail');
    if (!box || box.dataset.monelloPersonalReady === 'true') return;

    const cb = getPrimaryCheckbox(box);
    if (!cb) return;

    box.dataset.monelloPersonalReady = 'true';
    box.classList.add('monello-gpo-single');

    const source = cb.closest('.gpo-element') || cb.closest('.gpo-checkbox');
    if (source) source.classList.add('monello-gpo-single-source');

    syncSelected(box, cb);
    cb.addEventListener('change', () => syncSelected(box, cb));

    const trigger = box.querySelector('.monello-gpo-accordion__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      if (event.target.closest('a, input, select, textarea, button')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const nextChecked = !cb.checked;
      cb.click();

      const content = box.querySelector('.monello-gpo-accordion__content');
      box.classList.toggle('is-open', nextChecked);
      box.classList.toggle('is-selected', nextChecked);
      if (content) content.hidden = !nextChecked;
      trigger.setAttribute('aria-expanded', nextChecked ? 'true' : 'false');
    }, true);
  }

  function fixCharmTitle() {
    const box = findAccordionByText('weitere erinnerungen');
    if (!box) return;

    const heading = box.querySelector(
      '.monello-gpo-accordion__trigger .monello-upgrade-subhead, ' +
      '.monello-gpo-accordion__trigger .monello-upgrade-headline'
    );

    setTitlePreserveSubtext(heading, '💛 Charm-Verschluss am Gravurherz');
  }

  function run() {
    preparePersonalDetail();
    fixCharmTitle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.monelloGpoDetailCharmFixTimer);
    window.monelloGpoDetailCharmFixTimer = window.setTimeout(run, 120);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==================================================
   MONELLO GPO FINAL CLEAN + INNER SECTIONS
================================================== */
(function () {
  if (window.monelloGpoFinalCleanInitialized) return;
  window.monelloGpoFinalCleanInitialized = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function accordionByTrigger(fragment) {
    return Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((box) =>
      norm(box.querySelector('.monello-gpo-accordion__trigger')?.textContent).includes(fragment)
    );
  }

  function directChildContaining(content, node) {
    if (!content || !node) return null;
    return Array.from(content.children).find((child) => child.contains(node)) || null;
  }

  function hidePrimaryChoice(box) {
    const content = box?.querySelector('.monello-gpo-accordion__content');
    if (!content) return null;
    const cb = content.querySelector('input[type="checkbox"]');
    if (!cb) return null;
    const direct = directChildContaining(content, cb);
    if (direct) direct.classList.add('monello-gpo-single-source');
    const closest = cb.closest('.gpo-element, .gpo-checkbox, .gpo-checkbox-wrapper, .gpo-choice, .gpo-option');
    if (closest) closest.classList.add('monello-gpo-single-source');
    box.classList.add('monello-gpo-single');
    return cb;
  }

  function ensureDirectToggle(box) {
    if (!box || box.dataset.monelloDirectToggleFinal === 'true') return;
    const cb = hidePrimaryChoice(box);
    const trigger = box.querySelector('.monello-gpo-accordion__trigger');
    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!cb || !trigger || !content) return;

    box.dataset.monelloDirectToggleFinal = 'true';

    const sync = () => {
      box.classList.toggle('is-selected', !!cb.checked);
      if (!cb.checked) {
        box.classList.remove('is-open');
        content.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    };
    sync();
    cb.addEventListener('change', sync);

    trigger.addEventListener('click', function (event) {
      if (event.target.closest('a, input, select, textarea, button')) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      const next = !cb.checked;
      cb.click();

      box.classList.toggle('is-selected', next);
      box.classList.toggle('is-open', next);
      content.hidden = !next;
      trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
    }, true);
  }

  function addCharmConfirmation() {
    const box = accordionByTrigger('charm-verschluss am gravurherz');
    if (!box) return;
    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!content || content.querySelector('.monello-gpo-selection-confirm')) return;

    const note = document.createElement('div');
    note.className = 'monello-gpo-selection-confirm';
    note.innerHTML =
      '<span class="monello-gpo-selection-confirm__check">✓</span>' +
      '<span><strong>Charm-Verschluss ausgewählt</strong><br>Optional kannst du jetzt noch einen individuellen Charm ergänzen.</span>';
    content.prepend(note);
  }

  function hideRedundantIncludedNote(engravingBox) {
    const content = engravingBox?.querySelector('.monello-gpo-accordion__content');
    if (!content) return;
    Array.from(content.children).forEach((el) => {
      const t = norm(el.textContent);
      if (t === '⭐ im preis enthalten.' || t === 'im preis enthalten.' || t.includes('im preis enthalten')) {
        if (!el.querySelector('input,select,textarea,button')) el.classList.add('monello-gpo-redundant');
      }
    });
  }

  function fieldElementByText(content, terms) {
    const children = Array.from(content.children).filter((el) => !el.classList.contains('monello-gpo-single-source'));
    return children.find((el) => {
      const t = norm(el.textContent);
      return terms.some((term) => t.includes(term));
    }) || null;
  }

  function makeSection(className, title, text, elements) {
    const valid = elements.filter(Boolean);
    if (!valid.length) return null;
    if (valid.some((el) => el.closest('.monello-gpo-inner-section'))) return null;

    const first = valid[0];
    const parent = first.parentElement;
    if (!parent) return null;

    const section = document.createElement('div');
    section.className = 'monello-gpo-inner-section ' + className;

    const head = document.createElement('div');
    head.className = 'monello-gpo-inner-section__head';
    head.innerHTML =
      '<div class="monello-gpo-inner-section__title">' + title + '</div>' +
      (text ? '<div class="monello-gpo-inner-section__text">' + text + '</div>' : '');

    section.appendChild(head);
    parent.insertBefore(section, first);
    valid.forEach((el) => section.appendChild(el));
    return section;
  }

  function buildEngravingInnerSections() {
    const box = accordionByTrigger('deine persönliche gestaltung');
    const content = box?.querySelector('.monello-gpo-accordion__content');
    if (!box || !content || content.dataset.monelloInnerSectionsReady === 'true') return;

    hidePrimaryChoice(box);
    hideRedundantIncludedNote(box);

    const name = fieldElementByText(content, ['name deines tieres']);
    const life = fieldElementByText(content, ['lebensdaten']);
    const memory = fieldElementByText(content, ['erinnerungstext']);
    const font = fieldElementByText(content, ['schriftarten', 'schriftart']);
    const symbols = fieldElementByText(content, ['symbole']);

    const madeText = makeSection(
      'monello-gpo-inner-section--text',
      'Gravurtext',
      'Name, Lebensdaten und ein persönlicher Erinnerungstext.',
      [name, life, memory]
    );

    const madeFont = makeSection(
      'monello-gpo-inner-section--font',
      'Schriftart wählen',
      'Wähle die Schrift, die am besten zu deiner Erinnerung passt.',
      [font]
    );

    const madeSymbols = makeSection(
      'monello-gpo-inner-section--symbols',
      'Symbol wählen',
      'Ein kleines Symbol als liebevolles Detail.',
      [symbols]
    );

    if (madeText || madeFont || madeSymbols) {
      content.dataset.monelloInnerSectionsReady = 'true';
    }
  }

  function removeEmptyGaps() {
    const accordions = Array.from(document.querySelectorAll('.monello-gpo-accordion'));
    if (accordions.length < 2) return;

    const parents = [...new Set(accordions.map((a) => a.parentElement).filter(Boolean))];
    parents.forEach((parent) => {
      const kids = Array.from(parent.children);
      const accordionIdx = kids
        .map((el, i) => el.classList.contains('monello-gpo-accordion') ? i : -1)
        .filter((i) => i >= 0);
      if (accordionIdx.length < 2) return;

      const min = Math.min(...accordionIdx);
      const max = Math.max(...accordionIdx);

      kids.slice(min, max + 1).forEach((el) => {
        if (el.classList.contains('monello-gpo-accordion')) return;
        const hasControls = !!el.querySelector('input,select,textarea,button,a,img');
        const txt = norm(el.textContent);
        if (!hasControls && !txt) el.classList.add('monello-gpo-empty-gap');
      });
    });
  }

  function run() {
    const personal = accordionByTrigger('ein ganz persönliches detail');
    const charm = accordionByTrigger('charm-verschluss am gravurherz');
    if (personal) ensureDirectToggle(personal);
    if (charm) ensureDirectToggle(charm);
    addCharmConfirmation();
    buildEngravingInnerSections();
    removeEmptyGaps();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.monelloGpoFinalCleanTimer);
    window.monelloGpoFinalCleanTimer = window.setTimeout(run, 120);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==================================================
   MONELLO GPO ROBUST PERSONAL + GAP FIX
================================================== */
(function () {
  if (window.monelloGpoRobustFixInitialized) return;
  window.monelloGpoRobustFixInitialized = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function getAccordions() {
    return Array.from(document.querySelectorAll('.monello-gpo-accordion'));
  }

  function findBox(fragment) {
    return getAccordions().find((box) =>
      norm(box.querySelector('.monello-gpo-accordion__trigger')?.textContent).includes(fragment)
    );
  }

  function compactList() {
    const accs = getAccordions();
    if (accs.length < 2) return;

    const groups = new Map();
    accs.forEach((box) => {
      const p = box.parentElement;
      if (!p) return;
      if (!groups.has(p)) groups.set(p, []);
      groups.get(p).push(box);
    });

    groups.forEach((boxes, parent) => {
      if (boxes.length < 2) return;
      parent.classList.add('monello-gpo-accordion-list');

      const children = Array.from(parent.children);
      const indexes = boxes.map(b => children.indexOf(b)).filter(i => i >= 0);
      if (!indexes.length) return;

      const min = Math.min(...indexes);
      const max = Math.max(...indexes);

      children.slice(min, max + 1).forEach((el) => {
        if (el.classList.contains('monello-gpo-accordion')) return;

        const text = norm(el.textContent);
        const hasInteractive = !!el.querySelector('input, select, textarea, button, a');
        const hasVisual = !!el.querySelector('img, svg, video, canvas');

        if (
          (!text && !hasInteractive && !hasVisual) ||
          /spacing|spacer|abstand/i.test(el.className || '')
        ) {
          el.classList.add('monello-gpo-force-hide');
        }
      });
    });
  }

  function fixPersonalDetail() {
    const box = findBox('ein ganz persönliches detail');
    if (!box) return;

    box.classList.add('monello-gpo-personal-detail');

    const content = box.querySelector('.monello-gpo-accordion__content');
    const trigger = box.querySelector('.monello-gpo-accordion__trigger');
    if (!content || !trigger) return;

    /* gezielt die Checkbox "Ein ganz persönliches Detail nachbilden" finden */
    const checkbox = Array.from(content.querySelectorAll('input[type="checkbox"]')).find((cb) => {
      const holder = cb.closest('.gpo-element, .gpo-checkbox, .gpo-checkbox-wrapper, .gpo-choice, .gpo-option') || cb.parentElement;
      return norm(holder?.textContent).includes('ein ganz persönliches detail nachbilden');
    }) || content.querySelector('input[type="checkbox"]');

    if (!checkbox) return;

    /* kompletten direkten Inhaltsblock ausblenden */
    let source = checkbox.closest('.gpo-element, .gpo-checkbox, .gpo-checkbox-wrapper, .gpo-choice, .gpo-option');
    if (source) {
      while (source.parentElement && source.parentElement !== content) {
        const p = source.parentElement;
        if (p === content) break;
        if (p.classList.contains('gpo-element')) source = p;
        else break;
      }
    }
    if (source) source.classList.add('monello-gpo-personal-source');

    if (box.dataset.monelloRobustPersonalReady === 'true') return;
    box.dataset.monelloRobustPersonalReady = 'true';

    const sync = () => {
      const on = !!checkbox.checked;
      box.classList.toggle('is-selected', on);
      if (!on) {
        box.classList.remove('is-open');
        content.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    };
    checkbox.addEventListener('change', sync);
    sync();

    /* Dokument-Capture schlägt ältere Trigger-Handler zuverlässig */
    document.addEventListener('click', function handler(event) {
      const clicked = event.target.closest('.monello-gpo-personal-detail .monello-gpo-accordion__trigger');
      if (!clicked || clicked !== trigger) return;
      if (event.target.closest('a, input, select, textarea, button')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const next = !checkbox.checked;
      checkbox.click();

      box.classList.toggle('is-selected', next);
      box.classList.toggle('is-open', next);
      content.hidden = !next;
      trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
    }, true);
  }

  function run() {
    compactList();
    fixPersonalDetail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloGpoRobustFixTimer);
    window.monelloGpoRobustFixTimer = setTimeout(run, 100);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ==================================================
   MONELLO FINAL TOY + SPACING OVERRIDE
================================================== */
(function () {
  if (window.monelloFinalToySpacingOverride) return;
  window.monelloFinalToySpacingOverride = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function personalBox() {
    return Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((box) => {
      const t = norm(box.querySelector('.monello-gpo-accordion__trigger')?.textContent);
      return t.includes('ein ganz persönliches detail');
    }) || null;
  }

  function personalCheckbox(box) {
    const content = box?.querySelector('.monello-gpo-accordion__content');
    if (!content) return null;

    return Array.from(content.querySelectorAll('input[type="checkbox"]')).find((cb) => {
      let el = cb;
      for (let i = 0; i < 5 && el; i++, el = el.parentElement) {
        if (norm(el.textContent).includes('ein ganz persönliches detail nachbilden')) return true;
      }
      return false;
    }) || null;
  }

  function hideToyRow(box, cb) {
    if (!box || !cb) return;
    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!content) return;

    let candidate = cb.closest('.gpo-element, .gpo-checkbox, .gpo-checkbox-wrapper, .gpo-choice, .gpo-option');

    /* Falls Globo anders verschachtelt ist: kleinsten Block mit genau dieser Zeile nehmen */
    if (!candidate) {
      let el = cb.parentElement;
      while (el && el !== content) {
        const t = norm(el.textContent);
        if (t.includes('ein ganz persönliches detail nachbilden')) {
          candidate = el;
          break;
        }
        el = el.parentElement;
      }
    }

    if (!candidate) return;

    /* Nie den gesamten Accordion-Inhalt verstecken */
    if (candidate === content || candidate.contains(content)) return;

    candidate.classList.add('monello-force-hide');
    candidate.style.setProperty('display', 'none', 'important');
    candidate.style.setProperty('height', '0', 'important');
    candidate.style.setProperty('margin', '0', 'important');
    candidate.style.setProperty('padding', '0', 'important');
  }

  function syncPersonal(box, cb) {
    if (!box || !cb) return;
    const content = box.querySelector('.monello-gpo-accordion__content');
    const trigger = box.querySelector('.monello-gpo-accordion__trigger');
    const on = !!cb.checked;

    box.classList.toggle('is-selected', on);
    box.classList.toggle('is-open', on);

    if (content) content.hidden = !on;
    if (trigger) trigger.setAttribute('aria-expanded', on ? 'true' : 'false');

    hideToyRow(box, cb);
  }

  /* WINDOW capture läuft vor den älteren document/element Handlern */
  window.addEventListener('click', function (event) {
    const trigger = event.target.closest('.monello-gpo-accordion__trigger');
    if (!trigger) return;

    const box = trigger.closest('.monello-gpo-accordion');
    if (!box) return;

    const title = norm(trigger.textContent);
    if (!title.includes('ein ganz persönliches detail')) return;

    const cb = personalCheckbox(box);
    if (!cb) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    cb.click();
    syncPersonal(box, cb);
  }, true);

  function removeSpacing() {
    const roots = document.querySelectorAll('.gpo-app, .gpo-container');

    roots.forEach((root) => {
      const accordions = Array.from(root.querySelectorAll('.monello-gpo-accordion'));
      if (accordions.length < 2) return;

      /* Explizite Globo Spacer/Spacing-Elemente */
      root.querySelectorAll(
        '[class*="spacing"], [class*="spacer"], [data-type="spacing"], [data-element-type="spacing"]'
      ).forEach((el) => {
        if (!el.closest('.monello-gpo-accordion__content')) {
          el.classList.add('monello-force-hide');
        }
      });

      /* Leere gpo-Elemente mit sichtbarer Höhe zwischen den Karten */
      root.querySelectorAll('.gpo-element').forEach((el) => {
        if (el.closest('.monello-gpo-accordion__content')) return;
        if (el.closest('.monello-gpo-accordion')) return;

        const hasUseful = !!el.querySelector('input,select,textarea,button,a,img,svg,video');
        const text = norm(el.textContent);

        if (!hasUseful && !text) {
          const rect = el.getBoundingClientRect();
          if (rect.height >= 8) el.classList.add('monello-force-hide');
        }
      });
    });
  }

  function run() {
    const box = personalBox();
    const cb = personalCheckbox(box);
    if (box && cb) {
      hideToyRow(box, cb);
      syncPersonal(box, cb);
    }
    removeSpacing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloFinalToySpacingTimer);
    window.monelloFinalToySpacingTimer = setTimeout(run, 80);
  });

  observer.observe(document.documentElement, { childList:true, subtree:true });
})();


/* ==================================================
   MONELLO TOY DEDUP
================================================== */
(function () {
  if (window.monelloToyDedupInitialized) return;
  window.monelloToyDedupInitialized = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function run() {
    const box = Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((b) =>
      norm(b.querySelector('.monello-gpo-accordion__trigger')?.textContent).includes('ein ganz persönliches detail')
    );
    if (!box) return;

    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!content) return;

    Array.from(content.querySelectorAll('*')).forEach((el) => {
      if (el.classList.contains('monello-gpo-accordion__content')) return;

      const t = norm(el.textContent);
      const hasInteractive = !!el.querySelector('input,select,textarea,button,a');
      const hasVisual = !!el.querySelector('img,svg,video,canvas');

      if (!hasInteractive && !hasVisual) {
        if (
          t === '🧸 ein ganz persönliches detail nachbilden' ||
          t === 'ein ganz persönliches detail nachbilden' ||
          t === 'zum beispiel das lieblingsspielzeug oder einen gegenstand, der besonders zu deinem tier gehörte.' ||
          t === 'zum beispiel das lieblingsspielzeug oder einen gegenstand, der besonders zu deinem tier gehörte'
        ) {
          el.classList.add('monello-toy-duplicate');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloToyDedupTimer);
    window.monelloToyDedupTimer = setTimeout(run, 80);
  });
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();


/* ==================================================
   MONELLO TOY INNER LABEL HIDE FINAL
================================================== */
(function () {
  if (window.monelloToyInnerLabelHideFinal) return;
  window.monelloToyInnerLabelHideFinal = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function run() {
    const box = Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((b) =>
      norm(b.querySelector('.monello-gpo-accordion__trigger')?.textContent).includes('ein ganz persönliches detail')
    );
    if (!box) return;

    const content = box.querySelector('.monello-gpo-accordion__content');
    if (!content) return;

    /* Nur die Feldüberschrift des Globo-Bildmusters ausblenden */
    content.querySelectorAll(
      '.gpo-label, .gpo-form__label, label, .gpo-title, .gpo-name'
    ).forEach((el) => {
      const t = norm(el.textContent);
      if (
        t.includes('ein ganz persönliches detail nachbilden') ||
        t.includes('lieblingsspielzeug')
      ) {
        el.classList.add('monello-toy-inner-heading-hide');
      }
    });

    /* Nur die dazugehörige doppelte Beschreibung ausblenden */
    content.querySelectorAll(
      '.gpo-helptext, .gpo-help-text, .gpo-description, .gpo-help, small, p'
    ).forEach((el) => {
      const t = norm(el.textContent);
      if (
        t.includes('zum beispiel das lieblingsspielzeug') ||
        t.includes('gegenstand, der besonders zu deinem tier gehörte')
      ) {
        el.classList.add('monello-toy-inner-description-hide');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloToyInnerLabelHideTimer);
    window.monelloToyInnerLabelHideTimer = setTimeout(run, 80);
  });
  observer.observe(document.documentElement, {childList:true, subtree:true});
})();


/* ==================================================
   MONELLO TOY TEXT NODE FINAL FIX
   Entfernt nur die doppelten Texte, nicht die Auswahl
================================================== */
(function () {
  if (window.monelloToyTextNodeFinalFix) return;
  window.monelloToyTextNodeFinalFix = true;

  const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function getPersonalContent() {
    const box = Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((b) => {
      const t = normalize(b.querySelector('.monello-gpo-accordion__trigger')?.textContent);
      return t.includes('ein ganz persönliches detail');
    });
    return box?.querySelector('.monello-gpo-accordion__content') || null;
  }

  function removeDuplicateTextNodes() {
    const content = getPersonalContent();
    if (!content) return;

    const walker = document.createTreeWalker(
      content,
      NodeFilter.SHOW_TEXT,
      null
    );

    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach((textNode) => {
      const t = normalize(textNode.nodeValue);

      if (
        t.includes('ein ganz persönliches detail nachbilden') ||
        t.includes('zum beispiel das lieblingsspielzeug') ||
        t.includes('gegenstand, der besonders zu deinem tier gehörte')
      ) {
        textNode.nodeValue = '';
      }
    });
  }

  function run() {
    removeDuplicateTextNodes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloToyTextNodeFinalTimer);
    window.monelloToyTextNodeFinalTimer = setTimeout(run, 50);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();


/* ==================================================
   MONELLO TOY DUPLICATE OWN-TEXT FIX
================================================== */
(function () {
  if (window.monelloToyOwnTextFix) return;
  window.monelloToyOwnTextFix = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function ownText(el) {
    return Array.from(el.childNodes)
      .filter((n) => n.nodeType === Node.TEXT_NODE)
      .map((n) => n.nodeValue || '')
      .join(' ');
  }

  function getPersonalContent() {
    const box = Array.from(document.querySelectorAll('.monello-gpo-accordion')).find((b) =>
      norm(b.querySelector('.monello-gpo-accordion__trigger')?.textContent)
        .includes('ein ganz persönliches detail')
    );
    return box?.querySelector('.monello-gpo-accordion__content') || null;
  }

  function hideOwnTextMatches() {
    const content = getPersonalContent();
    if (!content) return;

    Array.from(content.querySelectorAll('*')).forEach((el) => {
      const t = norm(ownText(el));
      if (!t) return;

      const isDuplicateTitle =
        t.includes('ein ganz persönliches detail nachbilden');

      const isDuplicateDescription =
        t.includes('zum beispiel das lieblingsspielzeug') ||
        t.includes('gegenstand, der besonders zu deinem tier gehörte');

      if (!isDuplicateTitle && !isDuplicateDescription) return;

      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  }

  function run() {
    hideOwnTextMatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloToyOwnTextTimer);
    window.monelloToyOwnTextTimer = setTimeout(run, 60);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();


/* ==================================================
   MONELLO SHADOW DUPLICATE TEXT KILL
   Entfernt die doppelte Spielzeug-Beschriftung auch
   in von Apps separat gerenderten offenen Shadow-Roots.
================================================== */
(function () {
  if (window.monelloShadowDuplicateTextKill) return;
  window.monelloShadowDuplicateTextKill = true;

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const duplicateTexts = [
    '🧸 ein ganz persönliches detail nachbilden',
    'ein ganz persönliches detail nachbilden',
    'zum beispiel das lieblingsspielzeug oder einen gegenstand, der besonders zu deinem tier gehörte.',
    'zum beispiel das lieblingsspielzeug oder einen gegenstand, der besonders zu deinem tier gehörte'
  ];

  function shouldHide(text) {
    const t = norm(text);
    return duplicateTexts.some((x) => t === norm(x));
  }

  function scanRoot(root) {
    if (!root || !root.querySelectorAll) return;

    const all = Array.from(root.querySelectorAll('*'));

    all.forEach((el) => {
      if (!shouldHide(el.textContent)) return;

      /* Nur das kleinste passende Element ausblenden.
         Wenn ein Kind denselben exakten Text trägt, soll der Elternblock bleiben. */
      const childHasSame = Array.from(el.children || []).some((child) =>
        shouldHide(child.textContent)
      );
      if (childHasSame) return;

      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('border', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      el.setAttribute('data-monello-duplicate-hidden', 'true');
    });

    /* rekursiv offene Shadow Roots prüfen */
    all.forEach((el) => {
      if (el.shadowRoot) scanRoot(el.shadowRoot);
    });
  }

  function run() {
    scanRoot(document);

    /* auch spätere Globo-Renderings beobachten */
    document.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot && !el.shadowRoot.__monelloObserved) {
        el.shadowRoot.__monelloObserved = true;
        const o = new MutationObserver(() => scanRoot(el.shadowRoot));
        o.observe(el.shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver(() => {
    clearTimeout(window.monelloShadowDuplicateTimer);
    window.monelloShadowDuplicateTimer = setTimeout(run, 40);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
